import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const location = useLocation();

  const token = localStorage.getItem("gotasteadmintoken");
  const parentRestaurant = localStorage.getItem("parentrestaurant");

  // not logged in
  if (!token) {
 
    return <Navigate to="/login" state={{ from: location }}  replace />;
  }

  // logged in but restaurant not selected
  if (!parentRestaurant) {
   
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
